// extracted by mini-css-extract-plugin
module.exports = {"PageNav":"DItrt7t4I-LmoUvjoh2bXA=="};